module.exports = __webpack_public_path__ + "img/sleeve_opening.e0f559ee.png";